import MarkDownSection from 'components/MarkDownSection';
import React from 'react';

export interface IMarkDownContainer {
  content: {
    backgroundColor: string;
    slug: string;
    markdownField: {
      childMarkdownRemark?: {
        html: string;
      };
    };
  };
}

export const MarkDownContainer: React.FC<IMarkDownContainer> = ({
  content,
}) => {
  if (!content) {
    return null;
  }
  const { markdownField, slug, backgroundColor } = content;

  return (
    <MarkDownSection
      backgroundColor={backgroundColor}
      slug={slug}
      markdown={markdownField}
    />
  );
};

export default MarkDownContainer;
